import { Component, Input } from '@angular/core';
import { IotaTabsComponent } from '../iota-tabs.component';

@Component({
    standalone: false,
    selector: 'app-iota-tab-content',
    template: `
        <div
            class="block basis-full transition-all duration-300 ease-out"
            [ngClass]="{
                'translate-x-full absolute inset-0 invisible overflow-hidden': tabValue !== this.tabs.activeTab,
                'relative overflow-x-hidden overflow-y-auto z-[1] flex-grow': tabValue === this.tabs.activeTab
            }"
        >
            <div class="transition-all duration-300 ease-out" [ngClass]="{ 'translate-x-full': tabValue !== this.tabs.activeTab }">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styles: [':host { display: contents }']
})
export class IotaTabContentComponent {
    @Input() tabValue!: any;

    tabs: IotaTabsComponent;

    constructor(tabs: IotaTabsComponent) {
        this.tabs = tabs;
    }
}
